import { render, staticRenderFns } from "./businessDetails3.vue?vue&type=template&id=57bfdfe9&"
import script from "./businessDetails3.vue?vue&type=script&lang=js&"
export * from "./businessDetails3.vue?vue&type=script&lang=js&"
import style0 from "./businessDetails3.vue?vue&type=style&index=0&id=57bfdfe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports